import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core'
import { contactSearch } from 'actions/inbox'
import {
  withMobileDialog,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@material-ui/core'
import Button from 'components/theme/Button'
import { contact } from 'components/routes'
import List from 'components/ListView/List'
import { withRouter } from 'react-router-dom'
import { toggleDialog } from 'actions/view'

const styles = theme => ({
  rounded: {
    borderRadius: 28,
    overflowY: 'hidden',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      borderRadius: 0,
      overflowY: 'auto',
    },
  },
  dialogContentRoot: {
    padding: '0 12px 12px',
    '&:first-child': { paddingTop: 12 },
  },
})

const ContactDialog = ({
  classes,
  contactSearch,
  fullScreen,
  history,
  open,
  type,
  toggleDialog,
}) => {
  const typeTitleObj = {
    inbox: 'Click a contact to start a conversation',
    template: 'Click a contact to preview',
  }

  return (
    <Dialog
      fullWidth
      maxWidth="xl"
      fullScreen={fullScreen}
      open={open}
      onClose={() => toggleDialog({ open: false, dialog: 'contactList' })}
      aria-labelledby="responsive-dialog-title"
      // disableBackdropClick
      // disableEscapeKeyDown
      PaperProps={{ classes: { rounded: classes.rounded } }}
    >
      <DialogContent classes={{ root: classes.dialogContentRoot }}>
        <Typography
          style={{ fontSize: 20, textAlign: 'center', paddingBottom: 4 }}
        >
          {typeTitleObj?.[type] || 'Click a contact below'}
        </Typography>
        <List history={history} {...contact} modal />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            toggleDialog({ open: false, dialog: 'contactList' })
          }}
          color="primary"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default withRouter(
  connect(
    state => ({
      open: state.view.dialogs?.contactList?.open,
      type: state.view.dialogs?.contactList?.type,
    }),
    dispatch =>
      bindActionCreators(
        {
          contactSearch,
          toggleDialog,
        },
        dispatch,
      ),
  )(withStyles(styles)(withMobileDialog()(ContactDialog))),
)
